import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'app-routeaddtionalapproval',
    template: require('./routeaddtionalapproval.component.html'),
    styles: []
})

export class RouteAddtionalApprovalComponent implements OnInit {
    expDetails: any;
    private columnDefs;
    private rowData;
    private rowHeight;
    api: GridApi;
    columnApi: ColumnApi;
    defaultColDefine;
    busy: Subscription;
    private gridColumnApi: ColumnApi;
    private detailCellRendererParams;
    currentMonth: any;
    ManagerList: any;
    staff: any;
    designation: any;
    currentDate: any;
    userId: any = 0;
    ManagerID: any = 0;
    date: any = null;
    RouteData: any = [];
    routeId: any = [];
    rowSelectionMultiple: any;
    token:any;

    static parameters = [ApiService, ToastrService, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient, private toastr: ToastrService) {
        let parent = this;
        this.columnDefs = [
            { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
            {
                headerName: 'Action', field: 'action', width: 150, checkboxSelection: true, headerCheckboxSelection: true, 
                headerCheckboxSelectionFilteredOnly: true
                // , cellRenderer: function (params) {
                //     var eDiv = document.createElement('div');
                //     eDiv.innerHTML = `<input type="checkbox" id="` + params.data.RouteId + `"  class="viewBtn grid_actions_item"/>`;
                //     var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
                //     viewButton.addEventListener('change', function ($event) {
                //         let e: any = $event.target;
                //         if (e.checked == true) {
                //             parent.routeId.push(params.data.RouteId);
                //         }
                //         if (e.checked == false) {
                //             parent.routeId.pop(params.data.RouteId);
                //         }
                //         console.log('params data ', parent.routeId);
                //     });
                //     return eDiv;
                // }
            },
            { headerName: 'Employee Code', field: "EmployeeCode", filter: 'agTextColumnFilter' },
            { headerName: 'Employee Name', field: "EmployeeName", filter: 'agTextColumnFilter' },
            { headerName: 'Designation', field: "ClientTypeDesc", filter: 'agTextColumnFilter' },
            { headerName: 'Date', field: "Route_Date", filter: 'agTextColumnFilter' },
            { headerName: 'Route Name', field: "RouteName", filter: 'agTextColumnFilter' },
            { headerName: 'DA type', field: 'DAType', filter: 'agTextColumnFilter' },
            { headerName: 'KM', field: 'KM' },
            { headerName: 'No of visit in time', field: 'no_Of_Visit_In_A_Month' },
        ];
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    onFirstDataRendered(params) {
        setTimeout(function () {
            params.api.getDisplayedRowAtIndex(1).setExpanded(false);
        }, 0);
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.rowSelectionMultiple = 'multiple';
        this.routeId = [];
        this.userId = 0;
        this.ManagerID = 0;
        this.getManagerDetails();
        this.getExpDetails();
        var date = new Date();
        this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
        this.currentMonth = this.currentDate;
        console.log('currentDate', this.currentMonth);
        $('#filter-option').trigger('click');
    }

    ApproveRoute() {
        this.routeId = [];
        this.routeId = this.api.getSelectedRows();
        if(this.routeId.length == 0){
            alert("Please Select Route For Approval");
            return false;
        }
        var routeId = this.routeId.map(item => item.RouteId).toString();
        let token = JSON.parse(sessionStorage.getItem("currentUser"));        
        this.busy = this.apiService.ApproveRoute({ data: routeId, Id: token.clientId }).subscribe((res: any) => {
            //this.toastr.success(res.msg);
            alert("Route Approved Successfully");
            this.GetRouteFilterWise();
            this.routeId = []
        })
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    RejectRoute() {
        this.routeId = [];
        this.routeId = this.api.getSelectedRows();
        if(this.routeId.length == 0){
            alert("Please Select Route For Rejection");
            return false;
        }
        var routeId = this.routeId.map(item => item.RouteId).toString();
        let token = JSON.parse(sessionStorage.getItem("currentUser"));        
        this.busy = this.apiService.RejectRoute({ data: routeId, Id: token.clientId }).subscribe((res: any) => {
            //this.toastr.success(res.msg);
            alert("Route Rejected Successfully");
            this.GetRouteFilterWise();
            this.routeId = []
        });
    }

    GetRouteFilterWise() {
      //  console.log("filter", this.userId, this.date, this.clientType)
        let data = { userId: this.userId, date: this.date, ManagerID: this.ManagerID,
            LoginId: this.token.id };
        this.busy = this.apiService.GetRouteFilterWise(data).subscribe((res: any) => {
            this.RouteData = res.data;
            setTimeout(() => {
                this.gridColumnApi.autoSizeAllColumns();
            }, 200);
            // console.log('empDetails', this.expDetails);
        })

    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();

    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'ExpenseDetail' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    getExpDetails() {
        var data = {
            Id: this.token.id
        };
        this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.expDetails = res.data;
            console.log('empDetails', this.expDetails);
        })
    }
}
